import { AutomatedTargetingType } from './../../store/modules/ads_creative/const';
import i18n from './../../i18n';
export const AUDIENCE_SELECTION_OPTIONS = [
  {
    size: 12,
    activeColor: true,
    blockId: AutomatedTargetingType.OFF,
    title: 'module_audience_manual_title',
    backgroundColor: '#f8f8f9',
    teaName: 'data-tea-objective-content',
    teaContent: 'module_audience_manual_title',
  },
  {
    size: 12,
    activeColor: true,
    blockId: AutomatedTargetingType.ON,
    title: 'module_audience_automatic_title',
    backgroundColor: '#f8f8f9',
    teaName: 'data-tea-objective-content',
    teaContent: 'module_audience_automatic_title',
  },
];

export const INFO_TIPS = {
  title: i18n.t('module_broad_targeting_title'),
  content: i18n.t('module_broad_targeting_description'),
};
